import {
  brazeInitialise,
  conditionsMetToTrackUser,
} from "@theconversation/shared-libraries/braze-tc"
import { currentUser } from "lib/currentUser"

/**
 * This package is minimal glue between the Rails-specific features and the parts
 * that can exist in shared-libraries.
 */
export async function loadBrazeIfConditionsMet(sdkEndpoint: string, apiKey: string) {
  if (await conditionsMetToTrackUser()) {
    const user = await currentUser()
    const email = user ? user["email"] : null

    brazeInitialise(sdkEndpoint, apiKey, email)
  }
}
